import { DialogBase, dialogSizes } from 'dialogs/dialogBase'

class NotImplementedDialog extends DialogBase {
  modalSize () { return dialogSizes.SM }
  modalTitle () { return (this.props.context || {}).title || super.modalTitle() }
  modalBody () { return this.props.localize('common.notImplementedYet') }
}

export default NotImplementedDialog
